import { type PropsWithChildren } from 'react';
import clsx from 'clsx';
import ellipsesImage from 'assets/images/ellipses.webp';
import {
  backgroundCirclesOptimized as circlesImage,
  doubleCreditCardOptimized as creditCardImage,
} from 'assets/images/optimized-images';
import styles from './OfferCodeLayout.module.scss';

type Props = {
  title: string;
  description: string;
  ellipsesImagePath?: string;
  previewImagePath?: string;
  shadowImagePath?: string;
  iconContainerClassName?: string;
} & PropsWithChildren;

const OfferCodeLayout = ({
  description,
  title,
  children,
  ellipsesImagePath = ellipsesImage,
  previewImagePath = creditCardImage,
  shadowImagePath,
  iconContainerClassName,
}: Props) => {
  return (
    <div className={styles.container}>
      <section className={styles.contentContainer}>
        <h1 className={styles.title}>{title}</h1>
        <h2 className={styles.subtitle}>{description}</h2>
        {children}
      </section>

      <div className={clsx(styles.iconContainer, iconContainerClassName)} role="presentation">
        <img src={ellipsesImagePath} className={styles.ellipsesImage} alt="" />
        <img src={circlesImage} className={styles.circlesImage} alt="" />
        <img src={shadowImagePath} className={styles.shadowImage} alt="" />
        <img src={previewImagePath} className={styles.icon} alt="" fetchPriority="high" />
      </div>
    </div>
  );
};

export default OfferCodeLayout;
